import { defineStore } from "pinia";
import { computed, ref } from "vue";

const STORE = 'pageFilters';

const usePageFilterStore = defineStore(STORE, () => {
  const pageFilters = ref({});

  function setPageFilters(filters) {
    pageFilters.value = filters;
  }

  const activePageFilters = computed(() => {
    return Object.values(pageFilters.value)
      .filter(filter => filter.isActive || filter.options.length && filter.value !== 'Any')
      .map(({ field, type, value }) => ({ field, type, value }));
  });

  const activeHeaderFiltersByInstance = ref({});

  function setActiveHeaderFiltersByInstance(instanceId, filters) {
    activeHeaderFiltersByInstance.value[instanceId] = filters;
  }

  const activeHeaderFilters = computed(() => {
    return Object.values(activeHeaderFiltersByInstance.value).flat();
  });


  return {
    pageFilters,
    setPageFilters,
    activePageFilters,
    activeHeaderFilters,
    setActiveHeaderFiltersByInstance,
  };

});

export default usePageFilterStore;
